import { Backdrop } from "@mui/material";
import { MutatingDots } from "react-loader-spinner";
interface BackdropLoaderprops {
  openStates: boolean;
}
function BackdropLoader({ openStates }: Readonly<BackdropLoaderprops>) {
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: () => 9999 }}
      open={openStates}
    >
      <MutatingDots
        visible={openStates}
        height="100"
        width="100"
        color={"#002060"}
        secondaryColor={"#002060"}
        radius="12.5"
        ariaLabel="mutating-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </Backdrop>
  );
}

export default BackdropLoader;
